export default __webpack_public_path__ + "static/media/9.ef373865.png";